import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { heroSectionStyles } from '../styles';

export const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <Box sx={heroSectionStyles.background}>
      <Box sx={heroSectionStyles.content}>
        <Typography 
          variant="h1" 
          sx={heroSectionStyles.title}
        >
          {t('ecommerce.support.hero.title', 'Request a Quote or Roofing Delivery Assistance')}
        </Typography>
        <Typography 
          variant="h2" 
          sx={heroSectionStyles.subtitle}
        >
          {t('ecommerce.support.hero.subtitle', 'Need help placing an order, scheduling a delivery, or choosing the right product? Fill out the form and our team will contact you shortly.')}
        </Typography>
      </Box>
    </Box>
  );
};

export default HeroSection; 